<template>
  <!-- Table Container Card -->
  <b-card
    v-if="user.is_admin"
    no-body
  >
    <div class="m-2">
      <b-row>
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <!-- Per Page -->
          <list-per-page
            :total="total"
            :current-per-page="perPage"
            @onChangePerPage="changePerPage"
          />
          <b-button
            v-if="$can('create','faqs')"
            variant="success"
            @click="createButtonClicked"
          >
            {{ $t('Create faq') }}
            <feather-icon icon="PlusIcon" />
          </b-button>
        </b-col>
        <!-- Search -->
        <b-col
          cols="12"
          md="6"
        >
          <div class="d-flex align-items-center justify-content-end">
            <list-search @onSearch="search" />
          </div>
        </b-col>
      </b-row>
    </div>
    <table-loader v-if="loader" />
    <faqs-list
      v-else
      :fields="fields"
      :items="items"
    />

    <list-pagination
      :current="page"
      :current-per-page="perPage"
      :from="from"
      :to="to"
      :total="total"
      :total-page="totalPage"
      @onChangePage="changePage"
    />
  </b-card>
  <faqs-collapse
    v-else
    :items="items"
  />
</template>

<script>
import { ListIndex } from '../../common/mixins/list'
import FaqsList from '../../components/faqs/list/FaqsList'
import FaqsCollapse from '../../components/faqs/list/FaqsCollapse'

export default {
  components: {
    FaqsCollapse,
    FaqsList,
  },
  mixins: [ListIndex],
  data() {
    return {
      routeName: 'faqs',
      adminFields: [
        {
          key: 'id',
          label: this.$t('Id'),
        },
        {
          key: 'question',
          label: this.$t('Question'),
        },
        {
          key: 'answer',
          label: this.$t('Answer'),
        },
        {
          key: 'action',
          label: '',
        },
      ],
    }
  },
}
</script>

<style lang="scss">

</style>
